import { JSX, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useOutlet } from "react-router-dom";

import GroupTransition from "@/components/helpers/GroupTransition/GroupTransition.tsx";
import Spinner from "@/components/helpers/Spinner/Spinner.tsx";
import StaffNavigation from "@/components/staff/StaffNavigation.tsx";

import "./StaffLayout.css";

const StaffLayout = (): JSX.Element => {
  const { pathname } = useLocation();
  const outlet = useOutlet();
  const key = pathname.split("/")[2];
  const { t } = useTranslation();

  return (
    <div>
      <h1 className={"mt-14 hidden text-[2.75rem]/normal font-semibold max-lg:mt-7 max-lg:text-3xl/10 lg:block"}>
        {t("settings")}
      </h1>
      <div className={"mt-6 flex gap-10 max-lg:flex max-sm:mt-2"}>
        <StaffNavigation className={"w-[20.313rem] max-lg:hidden"} />
        <Suspense
          fallback={
            <div className={"flex  flex-1 items-center justify-center py-10"}>
              <Spinner />
            </div>
          }
        >
          <GroupTransition<HTMLDivElement> transitionKey={key}>
            {({ ref }) => (
              <div ref={ref} className={"w-0 flex-1"}>
                {outlet}
              </div>
            )}
          </GroupTransition>
        </Suspense>
      </div>
    </div>
  );
};

export default StaffLayout;
